export const customShadows = () => ({
  z1: '0 0 9px 0 rgba(85, 85, 85, 0.2)',
  z2: '0 6px 16px 0 rgba(0, 0, 0, 0.15)',
})
